import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const LightningSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3425 0.83274C15.6408 0.98583 15.8012 1.31831 15.7354 1.64708L14.3605 8.52169L19.7634 10.5477C19.9978 10.6357 20.1729 10.8348 20.2302 11.0786C20.2874 11.3224 20.2192 11.5787 20.0483 11.7617L9.5483 23.0117C9.31953 23.2568 8.95586 23.3203 8.65757 23.1673C8.35927 23.0142 8.19882 22.6817 8.26458 22.3529L9.6395 15.4783L4.23667 13.4522C4.0022 13.3643 3.82708 13.1652 3.76986 12.9214C3.71263 12.6776 3.78086 12.4213 3.95172 12.2383L14.4517 0.988258C14.6805 0.743145 15.0442 0.679651 15.3425 0.83274ZM5.81373 12.4416L10.7634 14.2977C11.1076 14.4269 11.3076 14.7865 11.2354 15.1471L10.2533 20.058L18.1863 11.5584L13.2367 9.70224C12.8924 9.57313 12.6925 9.21347 12.7646 8.85291L13.7468 3.94195L5.81373 12.4416Z"
        fill={color}
      />
    </svg>
  );
};

export { LightningSvg };
